'use client'

import { useEffect, useRef, useState } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { urlWithParams } from '@marketplace-web/shared/utils'

import { ChatKitGlobal, ChatKit } from '../types/chatkit'

export const useChatkit = () => {
  const [isOpen, setIsOpen] = useState(false)
  const chatkitRef = useRef<HTMLDivElement | null>(null)
  const isFsOn = useFeatureSwitch('chatkit_poc_internal')

  useEffect(() => {
    let chatkit: ChatKit | undefined

    if (!isFsOn) {
      return undefined
    }

    const cb = () => {
      if (chatkit) {
        chatkit.unmount()
        chatkit = undefined
        setIsOpen(false)
      } else {
        chatkit = ((window as any).ChatKit as ChatKitGlobal).create({
          apiURL: '/web/api/chatkit',
          mode: 'inline',
          header: {
            controls: {
              newThread: true,
            },
          },
          newThreadView: {
            greeting: 'Vintie - Your shopping assistant',
          },
          composer: {
            placeholder: 'Message Vintie',
          },
          clientTools: {
            set_search_query: ({ value }: { value: string }) => {
              window.history.pushState(
                null,
                '',
                urlWithParams(window.location.href, {
                  search_text: value,
                }),
              )
            },
          },
        })

        chatkit.mount(chatkitRef.current!)
        setIsOpen(true)
      }
    }

    window.addEventListener('ChatKit:toggle', cb)

    return () => {
      window.removeEventListener('ChatKit:toggle', cb)
      chatkit?.unmount()
      chatkit = undefined
    }
  }, [isFsOn])

  return { isOpen, chatkitRef }
}
